import React, { useState, useEffect } from "react";
import { toUpper } from "ramda";

const FacetPillLabel = ({ facet }) => {
  const [termLabel, setTermLabel] = useState("");
  useEffect(() => {
    const newTermLabel =
      facet.terms.length > 1
        ? `(${facet.terms.length})`
        : `"${facet.terms[0].label}"`;

    setTermLabel(newTermLabel);
  }, [facet.terms]);

  return (
    <div>
      <span style={{ fontWeight: "bold" }}>{toUpper(facet.displayName)}: </span>
      {termLabel}
    </div>
  );
};

export default FacetPillLabel;
